import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent implements OnInit {
  faTimes = faTimes;

  isCancelTextProvided = false;
  isOkTextProvided = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>
  ) {}

  ngOnInit(): void {
    if (this.data.cancelText) {
      this.isCancelTextProvided = true;
    }
    if (this.data.okText) {
      this.isOkTextProvided = true;
    }
  }

  get title(): string {
    return this.data.title ? this.data.title : 'Title';
  }

  get content(): string {
    return this.data.content ? this.data.content : 'Content';
  }

  get isCancelFnExist(): boolean {
    return typeof this.data.cancelFn === 'function';
  }

  get isOkFnExist(): boolean {
    return typeof this.data.okFn === 'function';
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
